// extracted by mini-css-extract-plugin
export default {"mCard":"oB-z","image":"pB-z","imageNoBackground":"qB-z","imageHasCategory":"rB-z","fullWidth":"sB-z"};